import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import { SmallContext } from '../utils';

import styles from './FilterBar.less';

const cxb = cx.bind(styles);

FilterBar.propTypes = {
  /** The number to show in the box */
  count: PropTypes.number,
  /** The label to show below the number */
  type: PropTypes.string,

  /** Disable all the inputs*/
  disabled: PropTypes.bool,

  /** Callback for when the form has been submited by the user */
  onSubmit: PropTypes.func,

  /** Callback for when the form has been reset by the user */
  onReset: PropTypes.func,
};

FilterBar.defaultProps = {
  onSubmit: (e) => void e.preventDefault(),
};

/**
 * **Access:**
 * ```js
 * import { Navigation } from '@iss/client-react-components'
 *
 * ...
 * render () {
 * 	return <Navigation.FilterBar .../>
 * }
 * ```
 *
 * The children of this component will be placed in the right panel area.  Components that have a small variant, and
 * support the SmallContext will render small.
 *
 * @component
 */
export default function FilterBar({ count, type, disabled, className, children, onSubmit, onReset, ...props }) {
  const formProps = [
    'accept',
    'acceptCharset',
    'action',
    'autoCapitalize',
    'autoComplete',
    'encType',
    'method',
    'name',
    'noValidate',
    'target',
  ].reduce((o, k) => {
    if (k in props) {
      o[k] = props[k];
      delete props[k];
    }
    return o;
  }, {});

  return (
    <div {...props} className={cx(cxb('root'), className)}>
      <div className={cxb('count')}>
        <Type.Heading1 className={cxb('value')}>{count}</Type.Heading1>
        <Type className={cxb('type')}>{type}</Type>
      </div>
      <SmallContext.Provider value={true}>
        <form className={cxb('controls')} onSubmit={onSubmit} onReset={onReset} disabled={disabled} {...formProps}>
          <div
            className={cxb('centerer')}
            children={React.Children.map(children, (x) =>
              !x || typeof x === 'string' || 'disabled' in x.props ? x : React.cloneElement(x, { disabled })
            )}
          />
        </form>
      </SmallContext.Provider>
    </div>
  );
}
